import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getBilateralTrade } from '@ebalance/proto/bffuser/v1/supply_bilateral_trade_service-SupplyBilateralTradeService_connectquery'
import {
  GetBilateralTradeRequestSchema,
  type GetBilateralTradeResponse,
} from '@ebalance/proto/bffuser/v1/supply_bilateral_trade_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 取引の full 情報を取得する hook。
 *
 * 手入力取引閲覧モーダル (`ManualTradeDetailModal`) が、 一覧の行より詳しい
 * full 情報 (受渡カレンダーの計算結果等) を表示するために使う。
 *
 * id が空文字の場合は query を無効化して fetch しない
 * (= modal が閉じている状態での無駄な fetch を避ける)。
 */
export function useGetBilateralTrade(
  id: string,
): UseQueryResult<GetBilateralTradeResponse, ConnectError> {
  const req = create(GetBilateralTradeRequestSchema, { id })
  return useQuery(getBilateralTrade, req, {
    enabled: id !== '',
  })
}
